export function resolveStorefrontName(store) {
  let altText = "storefront";
  if (store && store.city) {
    altText = `${store.city} storefront`;
  }
  return altText;
}
